import styled from "styled-components";
import {
  Field
} from "../Field";

const resetFieldStyles = `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  outline: none;
  border: 0px;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  width: 100%;`;

export const Input = styled("input") <{ skin; size }>`
  ${resetFieldStyles}
  height: calc(${(props) => props.theme.form.size[props.size].height} - 2px);
  line-height: ${(props) => props.theme.form.size[props.size].lineHeight};
  font-size: ${(props) => props.theme.form.size[props.size].fontSize};
  font-family: ${(props) => props.theme.fonts.family};
  color: ${(props) => props.theme.colors.Black};

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px
      ${(props) => props.theme.form.skin[props.skin].idle.backgroundColor} inset !important;
    background-color: transparent !important;
    background-image: none !important;
    color: ${(props) => props.theme.colors.Black} !important;
    font-family: ${(props) => props.theme.fonts.family};
    font-size: ${(props) => props.theme.form.size[props.size].mobileFontSize};
    line-height: ${(props) =>
    props.theme.form.size[props.size].mobileLineHeight};

    @media (min-width: 768px) {
      font-size: ${(props) => props.theme.form.size[props.size].fontSize};
      line-height: ${(props) => props.theme.form.size[props.size].lineHeight};
    }
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }
`;


export const Color = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  border-radius: 8px;
  overflow:hidden;
  box-shadow:  0px 1px 14px 0px rgba(0, 0, 0, 0.07);

  & > * {
    border-radius: 0;

    & > * {
      box-shadow: none!important;
    }
  }
`